export const IT: Record<string, string> = {
  "Home": "Pagina iniziale",
      "Resource Selected": "Risorsa selezionata",
      "Resources List": "Elenco delle risorse",
      "List": "Elenco",
      "Resources": "Risorse",
      "Find Colleague": "Trova collega",
      "Settings": "Impostazioni",
      "Floor Plan": "Pianta dell'edificio",
      "Locations": "Luoghi",
      "Categories": "Categorie",
      "Search resource name...": "Cerca nome risorsa...",
      "Calendar": "Calendario",
      "View Details": "Visualizza dettagli",
      "Add to My Favorites": "Aggiungi ai preferiti",
      "Remove": "Rimuovi",
      "Resource calendar": "Calendario delle risorse",
      "Today": "Oggi",
      "Previous month": "Mese precedente",
      "Next month": "Mese successivo",
      "Previous year": "Anno precedente",
      "Next year": "Anno successivo",
      "Close": "Chiudi",
      "Field is required.": "Campo obbligatorio.",
      "Invalid date format.": "Formato data non valido.",
      "S": "Dom",
      "M": "Lun",
      "T": "Mar",
      "W": "Mer",
      "F": "Ven",
      "January": "Gennaio",
      "February": "Febbraio",
      "March": "Marzo",
      "April": "Aprile",
      "May": "Maggio",
      "June": "Giugno",
      "July": "Luglio",
      "August": "Agosto",
      "September": "Settembre",
      "October": "Ottobre",
      "November": "Novembre",
      "December": "Dicembre",
      "Jan": "Gen",
      "Feb": "Feb",
      "Mar": "Mar",
      "Apr": "Apr",
      "Jun": "Giu",
      "Jul": "Lug",
      "Aug": "Ago",
      "Sep": "Set",
      "Oct": "Ott",
      "Nov": "Nov",
      "Dec": "Dic",
      "st": "°",
      "nd": "°",
      "rd": "°",
      "th": "°",
      "Sunday": "Domenica",
      "Monday": "Lunedì",
      "Tuesday": "Martedì",
      "Wednesday": "Mercoledì",
      "Thursday": "Giovedì",
      "Friday": "Venerdì",
      "Saturday": "Sabato",
      "Sun": "Dom",
      "Mon": "Lun",
      "Tue": "Mar",
      "Wed": "Mer",
      "Thu": "Gio",
      "Fri": "Ven",
      "Sat": "Sab",
      "Su": "Dom",
      "Mo": "Lun",
      "Tu": "Mar",
      "We": "Mer",
      "Th": "Gio",
      "Fr": "Ven",
      "Sa": "Sab",
      "PM": "pomeriggio",
      "AM": "mattina",
      "You cannot book this resource because your meeting request conflicts with the resource's booking policies.": "Non puoi prenotare questa risorsa perché la tua richiesta di incontro è in conflitto con le politiche di prenotazione della risorsa.",
      "You need permissions to interact with this resource.": "Hai bisogno di autorizzazioni per interagire con questa risorsa.",
      "Reason": "Motivo",
      "The resource cannot be booked {{day}} days in advanced.": "La risorsa non può essere prenotata {{day}} giorni in anticipo.",
      "The end date of a recurring meeting cannot be more than {{day}} days from today.": "La data di fine di una riunione ricorrente non può essere superiore a {{day}} giorni da oggi.",
      "Meeting duration cannot be longer than {{time}} minutes long.": "La durata della riunione non può superare i {{time}} minuti.",
      "Meeting duration cannot be shorter than {{time}} minutes long.": "La durata della riunione non può essere inferiore a {{time}} minuti.",
      "Booking policy": "Politica di prenotazione",
      "Available": "Disponibile",
      "Selected": "Selezionato",
      "Booked": "Prenotato",
      "Closed": "Chiuso",
      "Filter Options": "Opzioni di filtro",
      "{{resource}} is deleted": "{{resource}} è stato eliminato.",
      "This resource can be booked but any occurrences with conflicts the resource will not be booked.": "Questa risorsa può essere prenotata, ma le occorrenze con conflitti non verranno prenotate.",
      "This resource can be booked in advance for a maximum of {{day}} days, any occurrences beyond that limit will not be booked": "Questa risorsa può essere prenotata in anticipo per un massimo di {{day}} giorni, le occorrenze oltre tale limite non verranno prenotate.",
      "This resource can be booked, but the meeting duration must be at least {{time}} minutes.": "Questa risorsa può essere prenotata, ma la durata della riunione deve essere di almeno {{time}} minuti.",
      "This resource can be booked, but the meeting duration must not exceed {{time}} minutes.": "Questa risorsa può essere prenotata, ma la durata della riunione non deve superare i {{time}} minuti.",
      "Booking this resource requires approval by the resource's delegate. Your request will be forwarded, pending approval.": "La prenotazione di questa risorsa richiede l'approvazione da parte del delegato della risorsa. La tua richiesta verrà inoltrata in attesa di approvazione.",
      "Resource Name": "Nome della risorsa",
      "Description": "Descrizione",
      "Resource Mail": "Email della risorsa",
      "Location": "Posizione",
      "Capacity": "Capacità",
      "Language": "Lingua",
      "Select an language": "Seleziona una lingua",
      "Date/Time Format": "Formato data/ora",
      "First day of the week": "Primo giorno della settimana",
      "Please select a first day": "Seleziona un primo giorno",
      "Please select a time format": "Seleziona un formato orario",
      "Date Format": "Formato data",
      "Please select a date format": "Seleziona un formato data",
      "Date Separator": "Separatore data",
      "Please select a date separator": "Seleziona un separatore data",
      "Apply": "Applica",
      "Default Location": "Posizione predefinita",
      "Clear": "Cancella",
      "Help": "Aiuto",
      "Unavailable": "Non disponibile",
      "No data available": "Nessun dato disponibile",
      "More": "Di più",
      "Available Floor Plans": "Piani dell'edificio disponibili",
      "Default Categories": "Categorie predefinite",
      "List more Resources": "Elenca più risorse",
      "Attendees": "Partecipanti",
      "Click on Further information to visit our support site": "Fai clic su Altre informazioni per visitare il nostro sito di supporto",
      "New Order": "Nuovo Ordine",
      "Save default categories successfully": "Salva categorie predefinite con successo",
      "Save config date/time successfully": "Salva data/ora configurazione con successo",
      "Save language successfully": "Salva lingua con successo",
      "Save default location successfully": "Salva posizione predefinita con successo",
      "And": "E",
  "Or": "O",
  "Available occurrences of the series": "Occorrenze disponibili della serie",
  "Conflicting Occurrences": "Occorrenze in conflitto",
  "Availability": "Disponibilità",
  "Time Format": "Formato orario",
  "You do not have permission to book this resource.": "Non hai il permesso di prenotare questa risorsa.",
"This resource does not allow booking of recurring meetings.": "Questa risorsa non consente la prenotazione di riunioni ricorrenti.",
"You cannot book this resource.": "Non puoi prenotare questa risorsa."
};
